const LOCALE_COOKIE_NAME = 'locale';
const LOCALE_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export const getLocaleCookie = (): string | undefined => {
  if (typeof document === 'undefined') return undefined;

  const cookie = document.cookie.split('; ').find((entry) => entry.startsWith(`${LOCALE_COOKIE_NAME}=`));

  return cookie ? decodeURIComponent(cookie.slice(LOCALE_COOKIE_NAME.length + 1)) : undefined;
};

export const persistLocaleCookie = (locale: string): void => {
  if (typeof document === 'undefined') return;

  const secure = typeof window !== 'undefined' && window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${LOCALE_COOKIE_NAME}=${encodeURIComponent(locale)}; path=/; max-age=${LOCALE_COOKIE_MAX_AGE}; SameSite=Lax${secure}`;
};
